import colors from '../theme/colors';
import palette from '../theme/palette';
import { Theme } from '@mui/material/styles';
import { ComponentsOverrides } from '@mui/material/styles/overrides';
import { INPUT_BORDER_RADIUS } from '../theme/constants';

const styleOverrides: ComponentsOverrides['MuiOutlinedInput'] = {
  root: ({ ownerState, theme }) => ({
    background: palette.common.white,
    [`&.Mui-disabled`]: {
      opacity: 0.9,
      color: colors.transparentGray[400],
    },
    [`&:hover .MuiOutlinedInput-notchedOutline`]: {
      borderWidth: '2px',
      borderColor: colors.transparentGray[200],
      ...(ownerState?.error && {
        borderColor: palette.error.main,
      }),
    },
    [`&.Mui-disabled .MuiOutlinedInput-notchedOutline`]: {
      borderColor: colors.transparentGray[100],
    },
    [`&.Mui-disabled:hover .MuiOutlinedInput-notchedOutline`]: {
      borderColor: colors.transparentGray[100],
      borderWidth: '1px',
    },
    [`&.Mui-focused .MuiOutlinedInput-notchedOutline`]: {
      borderColor: palette.primary.main,
      borderWidth: '1px',
      ...(ownerState?.error && {
        borderColor: palette.error.main,
      }),
    },
    [`&.Mui-focused:hover .MuiOutlinedInput-notchedOutline`]: {
      borderColor: palette.primary.main,
      borderWidth: '2px',
      ...(ownerState?.error && {
        borderColor: palette.error.main,
      }),
    },
    ...(ownerState.color === 'internal' && {
      /**
       * Create stacking context.
       * Pseudo-element with internal background is placed below the select input.
       */
      '&': {
        isolation: 'isolate',
      },
      [`& > .MuiOutlinedInput-input`]: {
        background: palette.background.white,
      },
      [`&:after`]: {
        background: palette.background.internal,
        borderRadius: (theme as Theme).shape.borderRadius,
        display: 'block',
        zIndex: '-1',
        position: 'absolute',
        left: (theme as Theme).spacing(-0.75),
        top: (theme as Theme).spacing(-0.75),
        bottom: (theme as Theme).spacing(-0.75),
        right: (theme as Theme).spacing(-0.75),
        width: 'auto',
        height: 'auto',
        content: '""',
      },
    }),
  }),
  input: {
    padding: '10px 12px',
    borderRadius: INPUT_BORDER_RADIUS,
  },
  inputAdornedStart: {
    paddingLeft: 8,
  },
  inputAdornedEnd: {
    paddingRight: 8,
  },
  notchedOutline: {
    borderColor: colors.transparentGray[200],
  },
};

export default styleOverrides;
